/**
 * WEB-2054 — положить все куски рендерера блоков СРАЗУ, статически.
 *
 * Зовут два места, и оба — не публичный вход:
 *  - кабинет (`src/main.tsx`): превью конструктора рисует те же блоки тем же
 *    рендерером, и оно обязано появляться ТЕМ ЖЕ кадром, что и до разреза.
 *    Автор двигает блок мышью — ожидание чанка там видно сразу, а лишний вес
 *    кабинету не платит покупатель воронки;
 *  - тестовая обвязка (`jest.setup.ts`): сотни существующих тестов рисуют
 *    редкие виды блоков и читают их синхронно (`getBy…`). Ленивый путь у них
 *    проверяется отдельно и прицельно
 *    (`PublicBlockRendererGate.web2054.test.tsx`), а сам разрез доказывается не
 *    ими, а сторожем НАСТОЯЩЕЙ сборки (`publicEntry.build.web1988.test.ts`):
 *    он видит граф vite и краснеет, если кусок вернулся в первый экран.
 *
 * ПУБЛИЧНЫЙ вход (`src/public-main.tsx`) этот файл не импортирует и не должен:
 * статический импорт кусков отсюда вернул бы их покупателю первым экраном, и
 * это краснит `FIRST_SCREEN_DEFERRED_MODULES` в сторожe сборки.
 */
import { PublicBlockRendererExtended } from '@/components/editor/PublicBlockRendererExtended';
import { PortalBlocksRenderer } from '@/components/editor/blocks/PortalBlocksRenderer';
import { ReferenceBlocksRenderer } from '@/components/editor/blocks/ReferenceBlocksRenderer';
import { registerPublicBlockChunk } from './publicBlockChunkLoaders';

export function registerPublicBlockChunksEagerly(): void {
  registerPublicBlockChunk('extended', PublicBlockRendererExtended);
  registerPublicBlockChunk('portal', PortalBlocksRenderer);
  registerPublicBlockChunk('reference', ReferenceBlocksRenderer);
}
